import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";
import { formatImportTimestamp } from "@/hooks/use-import-persistence";

interface LastImportBadgeProps {
  importedAt: string | null;
  label?: string;
}

export function LastImportBadge({ importedAt, label = "Last saved" }: LastImportBadgeProps) {
  if (!importedAt) return null;
  
  return (
    <Badge variant="outline" className="gap-1.5 text-muted-foreground font-normal">
      <Clock className="h-3 w-3" />
      {label}: {formatImportTimestamp(importedAt)}
    </Badge>
  );
}
